import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        card: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(8),
            backgroundColor: 'background.light',
            borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
            padding: remCalc(16),
            color: 'text.default',
        },
        infoPopBox: {
            maxHeight: remCalc(16),
        },
    },
    parts: ['card'],
}
